import { useMemo } from 'react';

interface RowSelectionProps {
  data: any[];
  selectedRowIds: Record<string | number, boolean>;
  onSelectAll: () => void;
  onDeselectAll: () => void;
}

export const RowSelection = ({
  data,
  selectedRowIds,
  onSelectAll,
  onDeselectAll,
}: RowSelectionProps) => {
  const { selectedRowCount, allRowsSelected, noRowsSelected } = useMemo(() => {
    const selectedRowCount = Object.keys(selectedRowIds).length;
    const allRowsSelected = selectedRowCount === data.length;
    const noRowsSelected = selectedRowCount === 0;

    return { selectedRowCount, allRowsSelected, noRowsSelected };
  }, [selectedRowIds, data]);

  return (
    <div className="flex-1 text-sm text-muted-foreground">
      {noRowsSelected ? (
        `${data.length} rows`
      ) : allRowsSelected ? (
        <>
          {`All rows selected. `}
          <span
            style={{ textDecoration: 'underline', cursor: 'pointer' }}
            onClick={onDeselectAll}
          >
            Deselect all
          </span>
        </>
      ) : (
        <>
          {`${selectedRowCount} of ${data.length} rows selected. `}
          <span
            style={{ textDecoration: 'underline', cursor: 'pointer' }}
            onClick={onSelectAll}
          >
            Select all
          </span>
        </>
      )}
    </div>
  );
};
